import type { ImageAsset } from '../interfaces/image.interface'

type Quality = 'w200' | 'w512' | 'w1024' | 'raw' | 'raw-webp' | 'optimal'

const fileBucketUrl = ({
  key,
  baseUrl,
  quality = 'raw'
}: {
  key: string
  baseUrl: string
  quality: Quality
}): string => {
  // const baseUrl = `${import.meta.env.VITE_BUCKET_URL}/media/${quality}/${key}`;
  const url = `${baseUrl}/media/${quality}/${key}`

  return url
}

export const fileBucketOptimalUrl = ({
  key,
  baseUrl,
  optimalQuality
}: {
  key: string
  baseUrl: string
  optimalQuality: string
}): string => {
  // const url = `${import.meta.env.VITE_BUCKET_URL}/${optimal}/${key}`;
  const url = `${baseUrl}/${optimalQuality}/${key}`

  return url
}

const QUALITY_FALLBACK_ORDER: Quality[] = [
  'optimal',
  'w1024',
  'w512',
  'w200',
  'raw-webp',
  'raw'
]

export const fileUrlByAsset = ({
  asset,
  quality = 'raw'
}: {
  asset: ImageAsset | undefined | null
  quality?: Quality
}): string | null => {
  if (!asset?.baseUrl) return null

  const startIdx = QUALITY_FALLBACK_ORDER.indexOf(quality)
  const candidates =
    startIdx >= 0
      ? QUALITY_FALLBACK_ORDER.slice(startIdx)
      : QUALITY_FALLBACK_ORDER

  for (const q of candidates) {
    if (q === 'optimal') {
      if (asset.webpKey && asset.optimal) {
        return fileBucketOptimalUrl({
          key: asset.webpKey,
          baseUrl: asset.baseUrl,
          optimalQuality: asset.optimal
        })
      }
      continue
    }

    if (q === 'raw') {
      if (asset.key) {
        return fileBucketUrl({
          key: asset.key,
          baseUrl: asset.baseUrl,
          quality: 'raw'
        })
      }
      continue
    }

    if (asset.webpKey) {
      return fileBucketUrl({
        key: asset.webpKey,
        baseUrl: asset.baseUrl,
        quality: q
      })
    }
  }

  return null
}
